import * as React from 'react';
import { Linking, Pressable, StyleSheet, Text, View } from 'react-native';
import { translate } from 'secullum-i18n';
import { getTheme } from 'secullum-react-native-ui';

interface Props {
  src: string;
}

class VisualizadorImagem extends React.Component<Props> {
  render() {
    return (
      <View>
        <img src={this.props.src} style={{ width: '100%' }} />
        <View>
          <Pressable
            onPress={() => {
              Linking.openURL(this.props.src);
            }}
            style={({ pressed }) => [{ opacity: pressed ? 0.7 : 1 }]}
          >
            <Text
              nativeID="visualizador-imagem-download-arquivo"
              style={styles.link}
            >
              {translate('Download do Arquivo')}
            </Text>
          </Pressable>
        </View>
      </View>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  link: {
    paddingTop: 5,
    color: theme.textColor2
  }
});

export default VisualizadorImagem;
